var _circle, _path, _path2, _circle2, _circle3, _rect, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeavecompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.1603,
    cy: 65.1223,
    r: 60.3205,
    fill: "#E9F0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.043 114.874V31.6663H99.2773V114.874C89.574 121.541 77.8228 125.443 65.1603 125.443C52.4977 125.443 40.7463 121.541 31.043 114.874Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2461 111.214V33.7061V27.7061V27.7061L85.8736 17.9189V27.7061H98.0742H104.074V33.7061V111.214C102.172 112.822 100.168 114.314 98.0742 115.68V33.7061H85.8736V121.792C79.414 124.154 72.4377 125.443 65.1603 125.443C50.3303 125.443 36.7503 120.091 26.2461 111.214Z",
    fill: "#256AF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5459,
    cy: 83.4858,
    r: 3.88184,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.541,
    cy: 107.174,
    r: 25.791,
    fill: "#6CCC93"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.2773,
    y: 101.208,
    width: 22.4721,
    height: 11.9312,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.383 92.6135L123.556 107.174L107.383 121.734V92.6135Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavecompany);
export default __webpack_public_path__ + "static/media/leavecompany.4d4d6366ea574314294db554978106c3.svg";
export { ForwardRef as ReactComponent };